import Vue from 'vue'
import $ from 'jquery'

const BaseApi = {
    loadRoles: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/roles/list?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    createRole: function (reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/roles?time=' + new Date().getTime()
        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    loadById: function (itemId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/roles/' + itemId + '?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    deleteItem: function (companyId, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        $.get(Vue.prototype.$config.HOST + '/v1/roles/' + companyId + '/delete?time=' + new Date().getTime() + '&token=' + Vue.prototype.$api.getCredentials().authToken, function (data) {
            Vue.prototype.$api.hideIdle()
            if (fnOk) fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    },
    update: function (itemId, reqData, fnOk, fnFailed) {
        Vue.prototype.$api.showIdle()
        var cmp = this
        var url = Vue.prototype.$config.HOST + '/v1/roles/' + itemId + '?time=' + new Date().getTime()

        $.post(url, reqData, function (data) {
            Vue.prototype.$api.hideIdle()
            fnOk(data)
        }).catch(function (error, a, b, c) {
            if (fnFailed) {
                Vue.prototype.$api.hideIdle()
                fnFailed(error)
            } else {
                cmp.onGetError(error, a, b, c, fnFailed)
            }
        })
    }
}


export default BaseApi
